import { Anchor, Button, Checkbox, Modal, Text } from '@mantine/core';
import { useQueryClient } from '@tanstack/react-query';
import { useProfile } from 'init/use-enforce-profile';
import { useTranslation } from 'locales';
import { useState } from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import { useAcceptRecovrTos } from 'shared/hooks/use-accept-recovr-tos';
import { config } from 'store/constants';

export const AcceptTermsOfService = () => {
  const { currentLang } = useTranslation();
  const history = useHistory();
  const queryClient = useQueryClient();
  const profile = useProfile();

  const { acceptRecovrTos, isAcceptRecovrTosLoading } = useAcceptRecovrTos();
  const [areTosAccepted, setAreTosAccepted] = useState(false);

  if (profile.hasAcceptedGc) return <Redirect to="/dashboard" />;

  const link = config.terms[currentLang];

  const onClickProceed = () => {
    acceptRecovrTos(
      {},
      {
        onSuccess: () => {
          history.push('/dashboard');
          queryClient.invalidateQueries({ queryKey: ['profile'] });
        },
      },
    );
  };

  return (
    <Modal
      title="Accept terms of service"
      withCloseButton={false}
      centered
      opened
      onClose={() => {}}
    >
      <Text pb="lg" size="sm">
        In order to proceed to your platform, please review and accept our{' '}
        <Anchor href={link} target="_blank">
          Terms of Service
        </Anchor>
      </Text>
      <Checkbox
        size="sm"
        label="I accept the terms of service"
        checked={areTosAccepted}
        onChange={event => setAreTosAccepted(event.currentTarget.checked)}
      />
      <Button
        w="100%"
        mt="lg"
        disabled={!areTosAccepted}
        loading={isAcceptRecovrTosLoading}
        onClick={onClickProceed}
      >
        Proceed
      </Button>
    </Modal>
  );
};
